/**
 * illustrationsMap.js — Association fiche AM ↔ illustration.
 *
 * Priorité désormais donnée aux visuels HTML/CSS uniformisés
 * (Visuel*AM composants + VISUAL_CONFIGS via VisuelThemeCard) pour
 * garantir la conformité pédagogique et l'homogénéité visuelle.
 *
 * Format supporté :
 *   { custom: 'allure-am' }         → composant VisuelAllureAM
 *   { custom: 'regles-circulation-am' } → composant VisuelReglesCirculationAM
 *   { config: 'slug' }              → VisuelThemeCard avec VISUAL_CONFIGS[slug]
 *   { src, alt }                    → image PNG (fallback pour visuels
 *                                     spécifiques non uniformisés)
 */

const VOIT = '/images/voiturette';

export const FICHE_ILLUSTRATIONS = {
  // ─── Séquence 1 : Représentations ────────────────────────────────────────
  // (pas d'illustration — c'est un échange oral)

  // ─── Séquence 2 : Découverte + maîtrise Topolino ─────────────────────────
  't02': { src: `${VOIT}/voiturette-1-decouvre.png`,             alt: 'Découvrir ma voiturette Topolino' },
  't03': { src: `${VOIT}/voiturette-5-maitriser-vehicule.png`,   alt: "Maîtriser le véhicule — bonne installation" },
  't04': { config: 'entretien-vehicule',                         alt: 'Contrôles avant départ — pneus, freins, éclairage, niveaux' },
  't05': { src: `${VOIT}/voiturette-5-maitriser-vehicule.png`,   alt: 'Démarrer en maîtrisant le véhicule' },
  't06': { custom: 'allure-am',                                  alt: 'Adapter son allure — 45 km/h max en AM' },
  't07': { src: `${VOIT}/voiturette-3-freiner-arreter.png`,      alt: "Freiner et s'arrêter" },
  't08': { config: 'virages',                                    alt: 'Diriger dans les virages — regarder loin' },
  't09': { src: `${VOIT}/voiturette-2-regarder-controler.png`,   alt: 'Contrôler avant de reculer' },
  't10': { src: `${VOIT}/voiturette-6-stationner.png`,           alt: 'Stationner' },

  // ─── Séquence 3 : Règles ─────────────────────────────────────────────────
  't11': { config: 'signalisation',                              alt: 'La signalisation — interdiction, obligation, danger' },
  't12': { custom: 'regles-circulation-am',                      alt: 'En France, je roule à droite' },
  't13': { config: 'priorites',                                  alt: 'Les priorités aux intersections' },

  // ─── Séquence 4 : Circulation ────────────────────────────────────────────
  't14': { src: `${VOIT}/voiturette-2-regarder-controler.png`,   alt: 'Regarder loin, contrôler, anticiper' },
  't15': { src: `${VOIT}/voiturette-7-observer-communiquer.png`, alt: 'Observer et communiquer' },
  't16': { src: `${VOIT}/voiturette-7-observer-communiquer.png`, alt: 'Communiquer avec les autres usagers' },
  't17': { src: `${VOIT}/voiturette-9-giratoires.png`,           alt: 'Giratoire — bien se positionner' },
  't18': { src: `${VOIT}/voiturette-10-difference-vitesse-detaillee.png`, alt: 'Différence de vitesse 45 km/h vs autres' },
  't19': { src: `${VOIT}/voiturette-4-difference-vitesse.png`,   alt: "Dépasser ou être dépassé" },
  't20': { config: 'partage-route',                              alt: 'Partager la route avec les piétons' },
  't21': { config: 'partage-route',                              alt: 'Partager la route avec les cyclistes' },
  't22': { config: 'angles-morts',                               alt: 'Les angles morts' },
  't23': { config: 'angles-morts',                               alt: 'Attention aux véhicules lourds' },

  // ─── Séquence 5 : Risques ────────────────────────────────────────────────
  't24': { custom: 'allure-am',                                  alt: 'La vitesse — 45 km/h max en AM' },
  't25': { config: 'distances-securite',                         alt: 'Distances de sécurité — règle des 2 secondes' },
  't26': { config: 'conditions-circulation',                     alt: 'Météo — s\'adapter à la visibilité' },
  't27': { config: 'conditions-circulation',                     alt: 'Nuit et visibilité réduite' },
  't28': { config: 'risques-comportements',                      alt: 'Fatigue — un risque quotidien' },
  't29': { config: 'risques-comportements',                      alt: 'Téléphone au volant' },
  't30': { config: 'risques-comportements',                      alt: 'Alcool, drogues, médicaments' },
  't31': { config: 'risques-comportements',                      alt: 'Le passager — pression et distraction' },
  't32': { config: 'risques-comportements',                      alt: 'Pression du groupe' },
  't33': { config: 'risques-comportements',                      alt: 'Émotions et stress' },
  't34': { src: `${VOIT}/voiturette-1-decouvre.png`,             alt: 'Autonomie électrique de la Topolino' },
  // t35 (analyser) et t36 (mises en situation) : pas d'illustration
};

export function getFicheIllustration(ficheId) {
  return FICHE_ILLUSTRATIONS[ficheId] || null;
}

export default FICHE_ILLUSTRATIONS;
